const setting = {
  passwordTitle: "Wachtwoord",
  changePasswordBtn: "Wachtwoord wijzigen",
  changePasswordTips:"Als u uw wachtwoord bent vergeten of wilt wijzigen, kunt u dat hier doen; wij sturen een verificatiecode naar uw geregistreerde e-mailadres, dat moet worden geverifieerd om uw identiteit te bevestigen, en vervolgens kunt u het wachtwoord van uw account opnieuw instellen.",
  feedbackTitle: "Feedback",
  feedbackBtn: "Feedback geven",
  feedbackTips:"Om u beter van dienst te kunnen zijn, kunt u hier uw probleem beschrijven en het ons voorleggen voor feedback, en onze klantenservice zal zo spoedig mogelijk contact met u opnemen.",
  appearanceTitle: "Uiterlijk Weergave",
  appearanceBtn: "Verander Weergave",
  appearanceTips: "Wij kiezen twee verschijningsmodi voor u, zodat u kunt schakelen tussen donkere en lichte modi volgens uw voorkeur.",
  changePassWordModalTitle: "Wachtwoord wijzigen",
  changePassWordSameErrorTips: "Het nieuwe wachtwoord dat u heeft ingevoerd is hetzelfde als uw oude wachtwoord. Voer een ander wachtwoord in",
  changePasswordCurrentErrorTips: "Uw wachtwoord was onjuist. Probeer het opnieuw.",
  currentPasswordLabel: "Huidig wachtwoord",
  newPasswordLabel: "Nieuw wachtwoord",
  retypePasswordLabel: "Herhaal nieuw wachtwoord",
  changePasswordSuccessTips: "Uw wachtwoord is succesvol gewijzigd.",
  changePasswordComfirmDiffErrorTips: "Voer in beide velden hetzelfde wachtwoord in.",
  forgotPassword: "Wachtwoord vergeten?",
  feedbackModalSubtitle: "Bedankt dat u contact met ons heeft opgenomen en ons uw mening over het product heeft laten weten!",
  feedBackModalProductQuestion: "Wat voor soort problemen wilt u oplossen met ons product",
  feedBackModalProductTypeSug: "Suggesties",
  feedBackModalProductTypeMem: "Lid service gerelateerde vragen",
  feedBackModalProductTypeFun: "Functie onderzoek",
  feedBackModalProductTypeReq: "Product Eisen",
  feedBackModalProductTypeBug: "Feedback op product bugs",
  feedBackModalProductTypeIss: "Prestaties kwesties",
  feedBackModalProductTypeRL: "Registratie en login gerelateerde vragen",
  feedBackModalProductTypeRef: "Terugbetaling",
  feedBackModalProductTypeOth: "Overige",
  feedBackModalProductSelectQuestion: "Wat voor soort problemen wilt u oplossen met ons product",
  feedBackModalProductContQuestion: "Welk probleem heeft u ondervonden bij het gebruik van het product?",
  feedBackModalAddImageBtn: "Afbeeldingen toevoegen",
  feedBackModalTips: "Tips:",
  feedBackModalTipsCont: "Vanwege het tijdsverschil van de wereldwijde klantenservice, zullen wij u binnen 48 uur van de werkdag antwoorden;",
  feedBackSuccessTips: "Succesvol verzenden",
  feedBackSuccessSubTips: "We zullen uw probleem zo snel mogelijk oplossen",
  feedBackFailedTips: "Lukt niet met verzenden",
  feedBackFailedSubTips: "Controleer of uw netwerkverbinding werkt en verzend opnieuw",
  appearanceLightMode: "Lichte modus",
  appearanceDarkMode: "Donkere modus",
  promotionModalTitle: "Promotie",
  promoItem: "Promo artikel",
  promoCode: "Promo Code",
  discount: "Korting",
  applyBtn: "Toepassen",
  applyPromotionErrorTips: "Uw promotiecode is ongeldig",
};

export default setting;